import resetAllToggles from '../actions/resetAllToggles';
import { StructuredAnalysisHttpClient } from '../../services/httpClient';
import { keyParser } from '../utilities/linkedAdjustmentsUtilities';

const requestBuilder = (sourceAdjustment, targetAdjustment) => {
  const sourceItems = keyParser(sourceAdjustment);
  const targetItems = keyParser(targetAdjustment);

  return {
    sourceDocumentCode: sourceItems.code,
    sourceAdjustmentType: sourceItems.group,
    sourceAdjustmentNumber: parseInt(sourceItems.number, 10),
    sourceAdjustmentName: sourceItems.name,

    targetDocumentCode: targetItems.code,
    targetAdjustmentType: targetItems.group,
    targetAdjustmentNumber: parseInt(targetItems.number, 10),
    targetAdjustmentName: targetItems.name,
  };
};

const buildPathForStructuredAnalysisAdjustmentLinks = (projectId) =>
  `projects/${projectId}/structuredAnalysisAdjustmentLinks`;

const postLinkedAdjustment = async (
  projectId,
  sourceAdjustment,
  targetAdjustment
) => {
  const data = requestBuilder(sourceAdjustment, targetAdjustment);
  const response = await StructuredAnalysisHttpClient.post(
    `${buildPathForStructuredAnalysisAdjustmentLinks(projectId)}`,
    data
  );
  return response.data;
};
const deleteLinkedAdjustment = async (projectId, id) => {
  const response = await StructuredAnalysisHttpClient.delete(
    `${buildPathForStructuredAnalysisAdjustmentLinks(projectId)}/${id}`
  );
  return response.data;
};

const getDeletedLinkedAdjustments = (
  initialLinkedAdjustments = [],
  modifiedLinkedAdjustments = []
) => {
  return initialLinkedAdjustments.filter((ia) => {
    const wasNotDeleted = Boolean(
      modifiedLinkedAdjustments.find((ma) => ma.id === ia.id)
    );
    return !wasNotDeleted;
  });
};

export const saveLinkedAdjustments = async (
  projectId,
  initialLinkedAdjustments = [],
  modifiedLinkedAdjustments = [],
  dispatch
) => {
  const newLinkedAdjustments = modifiedLinkedAdjustments.filter(
    (la) => la.id === undefined && la.newId !== undefined
  );

  const deletedLinkedAdjustments = getDeletedLinkedAdjustments(
    initialLinkedAdjustments,
    modifiedLinkedAdjustments
  );

  if (newLinkedAdjustments.length > 0 || deletedLinkedAdjustments.length > 0) {
    dispatch(resetAllToggles());
  }

  await Promise.all([
    ...deletedLinkedAdjustments.map((dla) =>
      deleteLinkedAdjustment(projectId, dla.id)
    ),

    ...newLinkedAdjustments.map((adj) =>
      postLinkedAdjustment(
        projectId,
        adj.sourceAdjustment,
        adj.targetAdjustment
      )
    ),
  ]);
};

export const fetchLinkedAdjustmentsByCode = async (projectId, documentCode) => {
  try {
    const response = await StructuredAnalysisHttpClient.get(
      `${buildPathForStructuredAnalysisAdjustmentLinks(
        projectId
      )}/${documentCode}`
    );
    return response.data;
  } catch (error) {
    return [];
  }
};
